import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from  '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { PrivacyComponentComponent } from '../dialog/PrivacyDialog/privacy-component/privacy-component.component';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { AuthenticationService, PetsService } from '../_services';
import { Socialusers } from '../_models';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from 'src/environments/environment';
import {MAT_DIALOG_DATA} from '@angular/material';
import { Inject } from '@angular/core';
@Component({
  selector: 'app-otplogin',
  templateUrl: './otplogin.component.html',
  styleUrls: ['./otplogin.component.scss']
})
export class OTPloginComponent implements OnInit {
  socialusers = new Socialusers();
  public  email:  string  =  "";
  public  otp:  string  =  "";
  public aFormGroup!: FormGroup;
  public aFormGroup1!: FormGroup;
  public siteKey:any;
  OTPAPIResponse = new Socialusers();
  returnUrl: string;
  isSendOTP: boolean = true;
  isValidateOTP: boolean = false;
  public referPage: any = "";
  referUrl: string;
  constructor(private  dialog:  MatDialog, 
    private  router:  Router,
    public formBuilder:FormBuilder,
    private authenticationService: AuthenticationService,
		private SpinnerService: NgxSpinnerService,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    
  ngOnInit(): void {
    debugger;
    this.referUrl = this.route.snapshot.queryParams['refer'];
    this.referPage = this.route.snapshot.queryParams['referPage'];
    this.returnUrl = this.data;
    this.aFormGroup = this.formBuilder.group({
      recaptcha:['',Validators.required],
      email:['',Validators.required]
    });
    this.aFormGroup1 = this.formBuilder.group({      
      otp:['',Validators.required]
    });
    this.siteKey = "6LctOOwdAAAAAGx_-4gOS3f47m_YdeRvI0942nxQ";
        // $("#emailorphone").keydown(function(e) {
    //   debugger;
    //   var regExp = /[a-zA-Z]/g;
    //   var oldvalue=$(this).val();
    //   var field=this;
    //   if(regExp.test(oldvalue.toString())){
    //     if((<HTMLInputElement>field).value.indexOf('+47') !== 0) {
    //       $(field).val(oldvalue.toString().substring(3));
    //   }
    //   } else {
    //     setTimeout(function () {
    //           $(field).val("+47" + oldvalue);           
    //   }, 1);
    //   }      
    //   });
  }
  login(){
      this.SpinnerService.show();  
      this.authenticationService.sendOTP(this.email).subscribe((res: any) => {       
        this.isSendOTP = false;
        this.isValidateOTP = true; 
        this.SpinnerService.hide();         
      })
}
  validateOTP() {
    if (this.otp != "") {
      this.SpinnerService.show();  
      this.authenticationService.verifyOTP(this.email, this.otp).subscribe((res: any) => {
        debugger;
        this.OTPAPIResponse = res.Data;
      var retUrl = this.returnUrl;    
        if (res.Status == 1) {
          
          if (res.Data != null) {
            if (res.Data.IsNewUser) {
              if (res.Data.EmailID != null && res.Data.ContactNumber != null) {
                this.socialusers.ID = res.Data.ID;
                this.socialusers.FirstName = res.Data.firstName;
                this.socialusers.LastName = res.Data.lastName;
                this.socialusers.EmailID = res.Data.EmailID;
                this.socialusers.ContactNumber = res.Data.ContactNumber;
                this.socialusers.AuthToken = res.Data.authToken;
                this.socialusers.Provider = res.Data.provider;
                this.Savesresponse(this.socialusers,retUrl);
              } else {                
                this.socialusers.SocialID = Math.floor(100000000000000000000 + Math.random() * 1048947593516943422021).toString();
                this.socialusers.FirstName = "";
                this.socialusers.LastName = "";
                if(this.email.includes("@")){
                  this.socialusers.EmailID = this.email;
                }else{
                  this.socialusers.ContactNumber = this.email;
                }
                this.socialusers.AuthToken = "";
                this.socialusers.Provider = "OTP";
                this.Savesresponse(this.socialusers,"");                
              }
            } else {
              this.socialusers.ID = res.Data.ID;
              this.socialusers.FirstName = res.Data.firstName;
              this.socialusers.LastName = res.Data.lastName;
              this.socialusers.EmailID = res.Data.EmailID;
              this.socialusers.AuthToken = res.Data.authToken;
              this.socialusers.Provider = "OTP";
              this.Savesresponse(this.socialusers,retUrl);
            }
          } else {
            this.socialusers.SocialID = Math.floor(100000000000000000000 + Math.random() * 1048947593516943422021).toString();
                this.socialusers.FirstName = "";
                this.socialusers.LastName = "";
                if(this.email.includes("@")){
                  this.socialusers.EmailID = this.email;
                }else{
                  this.socialusers.ContactNumber = this.email;
                }
                this.socialusers.AuthToken = "";
                this.socialusers.Provider = "OTP";
                this.Savesresponse(this.socialusers,"");
          }
        }else{
          alert("Feil engangskode")
          this.SpinnerService.hide();
        }
      })
    }
    else {

    }
  }
Savesresponse(socialusers: Socialusers,retURL:string) {
  let currentUrl = '';
  // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';  
  this.authenticationService.login(socialusers).subscribe((res: any) => {
    this.socialusers = res.data;
    const today =  new Date();
    const tomorrow =  new Date(today.setDate(today.getDate() + 1));
    document.cookie = 'Authorization='+ res.JWTToken +'; expires=' + tomorrow;
    localStorage.setItem('socialusers', JSON.stringify(this.socialusers));
    if(retURL == ""){
    this.router.navigate(['userprofile']);
    }else{
      this.router.navigate([retURL]);
    }
    setTimeout(() => {
      this.SpinnerService.hide();
      window.location.reload();			        
    }, 500);
    
  })
}
}
